export default __webpack_public_path__ + "static/media/websafe-ext-ui-2.839a6d93.png";